import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-alert",
  "use": "icon-alert-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-alert\"><defs><style></style></defs><path d=\"M512 3.445C234.102 3.445 8.789 228.759 8.789 506.656c0 277.919 225.313 503.233 503.211 503.233 277.918 0 503.211-225.314 503.211-503.233C1015.232 228.76 789.94 3.445 512 3.445zm66.978 790.447H445.043v-114.61h133.935v114.61zm0-209.144H445.043V219.441h133.935v365.307z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol